module.exports = __webpack_public_path__ + "img/0-113.d01caedd.jpg";